const glossary = [
    { term: "1-on-1 meeting", definition: "A personal meeting between two people." },
    { term: "ABC", definition: "Always Be Closing – a sales mantra." },
    { term: "Backlog", definition: "A list of tasks or features yet to be done." },
    { term: "Buyer persona", definition: "A detailed description of a fictional target customer." },
    { term: "Conversion rate", definition: "Percentage of users who take a desired action." },
    // ... more
  ];
  
  export default glossary;
  